import { render, staticRenderFns } from "./VWave.vue?vue&type=template&id=0aa522be&"
import script from "./VWave.vue?vue&type=script&lang=js&"
export * from "./VWave.vue?vue&type=script&lang=js&"
import style0 from "./VWave.vue?vue&type=style&index=0&id=0aa522be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports